// Adresses du site dans chaque langue. Le français reste la langue par défaut (sans préfixe) ;
// l'anglais vit sous /en. Les slugs produits et articles sont les mêmes dans les deux langues.
export const LOCALES = ['fr', 'en'];
export const DEFAULT_LOCALE = 'fr';

export const ROUTE_PAIRS = [
  ['/', '/en'],
  ['/boutique', '/en/shop'],
  ['/produit/:slug', '/en/product/:slug'],
  ['/panier', '/en/cart'],
  ['/checkout', '/en/checkout'],
  ['/commande-confirmee', '/en/order-confirmed'],
  ['/a-propos', '/en/about'],
  ['/contact', '/en/contact'],
  ['/connexion', '/en/login'],
  ['/inscription', '/en/register'],
  ['/mot-de-passe-oublie', '/en/forgot-password'],
  ['/reinitialiser-mot-de-passe', '/en/reset-password'],
  ['/compte', '/en/account'],
  ['/journal', '/en/journal'],
  ['/journal/:slug', '/en/journal/:slug'],
  ['/mentions-legales', '/en/legal-notice'],
  ['/cgv', '/en/terms'],
  ['/confidentialite', '/en/privacy'],
  ['/livraison', '/en/shipping'],
];

export function localeFromPath(pathname = '/') {
  return pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'fr';
}

function matchPattern(pattern, pathname) {
  const patternParts = pattern.split('/').filter(Boolean);
  const pathParts = pathname.split('/').filter(Boolean);
  if (patternParts.length !== pathParts.length) return null;
  const params = {};
  for (let i = 0; i < patternParts.length; i += 1) {
    if (patternParts[i].startsWith(':')) params[patternParts[i].slice(1)] = pathParts[i];
    else if (patternParts[i] !== pathParts[i]) return null;
  }
  return params;
}

function fillPattern(pattern, params) {
  return pattern.replace(/:(\w+)/g, (_, name) => params[name] ?? '');
}

function splitPath(path) {
  const match = String(path).match(/^([^?#]*)(.*)$/);
  return [match[1] || '/', match[2] || ''];
}

// Traduit une adresse vers la langue voulue. Une adresse inconnue (admin, sur mesure…) est
// rendue telle quelle ; `fallback` choisit ce qu'on renvoie alors.
export function translatePath(path, targetLocale, { fallback = 'same' } = {}) {
  const [pathname, rest] = splitPath(path);
  const sourceLocale = localeFromPath(pathname);
  const from = sourceLocale === 'en' ? 1 : 0;
  const to = targetLocale === 'en' ? 1 : 0;
  const clean = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  for (const pair of ROUTE_PAIRS) {
    const params = matchPattern(pair[from], clean);
    if (params) return fillPattern(pair[to], params) + rest;
  }
  if (fallback === 'home') return ROUTE_PAIRS[0][to];
  return path;
}

// Les liens du code sont écrits en français (« /boutique ») : on les convertit selon la langue.
export function localizePath(frenchPath, locale) {
  if (locale === DEFAULT_LOCALE || typeof frenchPath !== 'string' || !frenchPath.startsWith('/')) return frenchPath;
  return translatePath(frenchPath, locale);
}
